// ─── Admin Panel Configuration ────────────────────────────────────────────────
// All admin-specific settings live here.
//
// CONFIGURING THE BACKEND URL
// ────────────────────────────
// Create admin/.env (copy .env.example) and set:
//   VITE_BACKEND_URL=http://localhost:5001   ← backend origin (no /api)
//   VITE_API_URL=http://localhost:5001/api   ← used in prod builds
//
// In development the Vite proxy forwards /api/* to VITE_BACKEND_URL, so the
// browser always talks to localhost:5174 → no CORS issues.

export const ADMIN_CONFIG = {
  // LocalStorage key for the admin JWT
  tokenKey: 'dd_admin_token',

  // Full API base URL injected at build time via vite.config.ts define block.
  // In DEV this is only used for display (the actual requests use /api via proxy).
  apiBase: 'http://localhost:5001/api',

  // Auto-refresh dashboard data every N milliseconds
  autoRefreshInterval: 60_000,

  // Default page size for admin list queries
  paginationLimit: 100,

  // Agent commission settings
  agentCommissionRate: 80, // 80% released to agent biweekly
  payoutSchedule: 'biweekly' as const,

  // Free-user limits (mirrored here for admin awareness)
  freeUserMessageLimit: 5,
  freeUserViewLimit: 10,

  // Admin route
  adminRoute: '/admin',

  // Support contact
  supportEmail: 'admin@dulhadulhun.com',
} as const;

export type AdminConfig = typeof ADMIN_CONFIG;
